import ApiHandler from "./ApiHandler";

const Discipline = {
  getAll: async () => await ApiHandler.i.auth().get('/discipline'),
  getOne: async (disciplineId) => await ApiHandler.i.auth().get(`/discipline/${disciplineId}`),
};

export default Discipline;